import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
    ObfuscateVisibilityPosition,
    ObfuscationMethod,
    ReusableFunctions,
} from '../../classes/reusable-functions';

@Component({
    selector: 'app-loan-card-contact-dialog',
    templateUrl: './loan-card-contact-dialog.component.html',
    styleUrls: ['./loan-card-contact-dialog.component.css'],
})
export class LoanCardContactDialogComponent implements OnInit {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private reusableFunctions: ReusableFunctions
    ) {}

    ngOnInit(): void {}

    formatPhone(number: string) {
        if (number && number.length == 10) {
            var cleaned = ('' + number).replace(/\D/g, '');
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return '' + match[1] + '-' + match[2] + '-' + match[3];
            }
        }

        return number;
    }

    formatEmailTo() {
        const to: string = this.data.email;
        let subject: string;
        let email: string;

        let obfuscatedLoanNumber = this.reusableFunctions.obfuscate(
            this.data.loanNumber,
            ObfuscateVisibilityPosition.End,
            4,
            'X'
        );

        try {
            let borrower = this.data.borrower;
            if (borrower) {
                let obfuscatedBorrowerName: string = '';
                if (this.reusableFunctions.isCorporateName(borrower)) {
                    obfuscatedBorrowerName = this.reusableFunctions.getCorporateName(
                        borrower,
                        true,
                        ObfuscationMethod.ReturnInitialOnly
                    );
                } else {
                    const borrowerFirstname: string = this.reusableFunctions.getFirstName(
                        borrower,
                        true,
                        true
                    );
                    const borrowerLastname: string = this.reusableFunctions.getLastName(
                        borrower,
                        true
                    );
                    obfuscatedBorrowerName = borrowerLastname + ', ' + borrowerFirstname + '.';
                }
                subject = `${obfuscatedBorrowerName} ${obfuscatedLoanNumber}`;
            } else {
                subject = `#${obfuscatedLoanNumber}`;
            }

            email = `mailto:${to}?subject=${subject}`;
        } catch (e) {
            email = `mailto:${to}`;
        }

        return email;
    }
}
